/**
 * Constants for the Reflection Flow
 * Centralizes magic numbers and configuration values
 */

export const REFLECTION_CONSTANTS = {
	/** Maximum number of questions before generating summary */
	MAX_QUESTIONS: 6,

	/** Maximum questions when diving deeper */
	MAX_DIVE_DEEPER_QUESTIONS: 10,

	/** Auto-save interval in milliseconds */
	AUTO_SAVE_INTERVAL_MS: 30000,

	/** Minimum required selections for contributing factors */
	MIN_CONTRIBUTING_FACTORS: 1,

	/** Minimum required selections for signals */
	MIN_SIGNALS: 1,

	/** Minimum required selections for corrective actions */
	MIN_CORRECTIVE_ACTIONS: 1,

	/** Maximum length for reflection title */
	MAX_TITLE_LENGTH: 200,

	/** Maximum length for reflection description */
	MAX_DESCRIPTION_LENGTH: 5000,
} as const;

/**
 * Step order for the reflection flow
 */
export const REFLECTION_STEPS = [
	"intro",
	"questions",
	"description",
	"contributing-factors-intro",
	"contributing-factors",
	"signals-intro",
	"signals",
	"future-state",
	"corrective-actions-intro",
	"corrective-actions",
	"linking",
	"summary",
] as const;

export type ReflectionStep = (typeof REFLECTION_STEPS)[number];
